import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { AccAdminRoutingModule } from './acc-admin-routing.module';
import { AccAdminComponent } from './acc-admin.component';
import { SharedModule } from '../helper/shared.module';

@NgModule({
  declarations: [
    AccAdminComponent,
  ],
  imports: [
    AccAdminRoutingModule,
    CommonModule,
    FormsModule,
    SharedModule,

    MatButtonModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatOptionModule,
    MatSelectModule,
    MatTooltipModule,

    NgxMatSelectSearchModule,
  ],
  exports: []
})
export class AccAdminModule {

}
